exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np {\n    margin-bottom: 6px;\n}\np i {\n    color: orange;\n    margin-right: 4px;\n}\np > span {\n    color: green;\n}\np button {\n    margin-left: 8px;\n}\n.StatNumber {\n    color: red;\n    font-weight: bold;\n    padding-left: 4px;\n    padding-right: 4px;\n}\n.ivu-table-cell {\n    padding: 0 !important;\n}\n\n/* .ivu-card-head {\n    padding: 4px 16px !important;\n    border-bottom: 1px solid #e8eaec !important;\n    line-height: 0 !important;\n}\n\n.upperCard {\n    height: 260px;\n    overflow:scroll;\n} */\n.upperCard::-webkit-scrollbar { width: 0 !important\n}\n", ""]);

// exports
